<template>
  <section class="two-players-preview">
    <div>
      <h2>Two players side by side</h2>
    </div>

    <div>
      <button class="button" @click="playFirst" :disabled="!canPlayFirst">Play first</button>
      <button class="button" @click="playNext" :disabled="!canPlayNext">Play next</button>
    </div>

    <div class="row">
      <div class="video-el">
        <video id="classic_vid_1"></video>
      </div>
      <div class="video-el">
        <video id="classic_vid_2"></video>
      </div>
    </div>
  </section>
</template>

<script>
import { PLAYLIST_CONFIGS } from '../playlist/configs.js';

let players = [];

export default {
  name: 'two-players-preview',
  components: {},
  props: [],
  data () {
    return {
      canPlayFirst: true,
      canPlayNext: false,
    };
  },
  computed: {},
  watch: {},
  mounted () {
    players = [
      new clpp.Player(document.getElementById('classic_vid_1')),
      new clpp.Player(document.getElementById('classic_vid_2')),
    ];
  },
  destroyed () {},
  methods: {
    async playFirst () {
      await players[0].load(PLAYLIST_CONFIGS[0]);
      this.canPlayFirst = false;
      this.canPlayNext = true;
    },
    async playNext () {
      await players[0].unload();
      await players[1].load(PLAYLIST_CONFIGS[1]);
      this.canPlayNext = false;
    }
  }
};
</script>

<style scoped lang="scss">
  @import 'styles.scss';
</style>
